module.exports = __webpack_public_path__ + "static/media/Icon open-reload.48cc8a5d.svg";